module.exports = __webpack_public_path__ + "static/media/maps.5ced2044.png";